import TemplatesApi from '../TemplatesApi';
import * as types from './ActionTypes';

function getTemplateListSuccess(result: any) {
    return { type: types.GET_TEMPLATE_LIST_SUCCESS, result };
}

export function getTemplates() {
    return function (dispatch: (result: any) => void) {
        return TemplatesApi.getTemplates().then((result: any) => {
            dispatch(getTemplateListSuccess(result));
        });
    };
}

function editTemplateSuccess(result: any) {
    return { type: types.EDIT_TEMPLATE_SUCCESS, result };
}

export function editTemplate(key: number) {
    return function (dispatch: (result: any) => void) {
        return TemplatesApi.editTemplate(key).then((result: any) => {
            dispatch(editTemplateSuccess(result));
        });
    };
}

function updateTemplateSuccess(result: any) {
    return { type: types.UPDATE_TEMPLATE_SUCCESS, result };
}

export function updateTemplate(key: string, data: any) {
    return function (dispatch: (result: any) => void) {
        return TemplatesApi.updateTemplate(key, data).then((result: any) => {
            dispatch(updateTemplateSuccess(result));
        });
    };
}
